export function InputSanitizers(event) {
  event.target.value = event.target.value
    .replace(/[^\d+]/g, '')  // Remove all non-digit and non-plus characters
    .replace(/(?!^)\+/g, ''); // Remove all '+' characters except the first one
}